// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"TabsContainer_tabHeader___TOA0"};